<div class="whats-new">
  <button
    type="button"
    class="whats-new__close"
    aria-label="Close"
    (click)="close()"
  >
    <mat-icon>close</mat-icon>
  </button>

  <div class="whats-new__header">
    <span class="whats-new__mark" aria-hidden="true">
      <svg viewBox="12 8 28 30" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="currentColor"
          d="M22.5921 19.2175H22.5636L22.5445 19.2387L16.8908 25.4825L16.8742 25.5009V25.5257V27.4517V27.4744L16.8885 27.4921L22.946 34.9785L22.9652 35.0023H22.996H27.0964H27.2326L27.146 34.8972L20.2231 26.4907L26.7401 19.3251L26.8379 19.2175H26.6926H22.5921Z"
        />
        <path
          fill="currentColor"
          d="M28.8256 27.1742H28.8541L28.8733 27.1531L34.5269 20.9092L34.5435 20.8909V20.8661V18.9401V18.9174L34.5292 18.8997L28.4718 11.4133L28.4524 11.3894H28.4218H24.3214H24.1851L24.2717 11.4946L31.1947 19.901L24.6776 27.0667L24.5798 27.1742H24.7252H28.8256Z"
        />
      </svg>
    </span>
    <div class="whats-new__heading">
      <p class="whats-new__title">What's new</p>
      <p class="whats-new__subtitle">
        Cockpit
        <span class="whats-new__version">v{{ data.version }}</span>
      </p>
    </div>
  </div>

  <div class="whats-new__items">
    <div
      class="whats-new__item"
      *ngFor="let item of data.items"
      [ngClass]="'whats-new__item--' + item.category"
    >
      <span class="whats-new__chip">
        <mat-icon>{{ categoryIcon(item.category) }}</mat-icon>
      </span>
      <div class="whats-new__item-text">
        <span class="whats-new__category">{{
          categoryLabel(item.category)
        }}</span>
        <p class="whats-new__item-title">{{ item.title }}</p>
        <p class="whats-new__item-description">{{ item.description }}</p>
      </div>
    </div>
  </div>

  <div class="whats-new__footer">
    <span class="whats-new__date" *ngIf="data.date">
      Released {{ data.date | date: 'mediumDate' }}
    </span>
    <button
      id="whats-new-got-it-button"
      type="button"
      class="whats-new__btn"
      (click)="close()"
    >
      Got it
    </button>
  </div>
</div>
